import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/i93NFP9TDRpFm3tk93ov5M/creative-kids-posing.jpg',
    alt: 'Creative kids with painted hands at Funtastic Kidz Early Learning Centre Wyndham Vale'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/cpvEPqgrngxUYT2o3QmMvj/nursery-children-playing-with-teacher-in-the-classroom.jpg',
    alt: 'Nursery children playing with educator at Funtastic Kidz Early Learning Centre Wyndham Vale'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kEJPbWkajEwcVMRKQddBhV/children-playing-together-in-the-classroom-in-kindergarten-.jpg',
    alt: 'Children playing together at Funtastic Kidz Early Learning Centre Wyndham Vale'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/qoZ6jM3fKXWK3u4d1KwCec/shot-of-a-teacher-singing-with-her-preschool-children.jpg',
    alt: 'Teacher singing with preschool children at Funtastic Kidz Early Learning Centre Wyndham Vale'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/cgkdVezvMH87xH8pYRd5CT/kid-is-learning-in-class.jpg',
    alt: 'Child learning in class at Funtastic Kidz Early Learning Centre Wyndham Vale'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/i93NFP9TDRpFm3tk93ov5M/creative-kids-posing.jpg',
    alt: 'Art station at Funtastic Kidz Early Learning Centre Wyndham Vale'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/cpvEPqgrngxUYT2o3QmMvj/nursery-children-playing-with-teacher-in-the-classroom.jpg',
    alt: 'Educators with children at Funtastic Kidz Early Learning Centre Wyndham Vale'
  }];
  return <section className="py-12 bg-white overflow-hidden border-b border-sand" data-id="element-207">
      <div className="max-w-7xl mx-auto px-6 mb-8" data-id="element-208">
        <h2 className="text-2xl font-extrabold text-navy" data-id="element-209">
          Take a look inside.
        </h2>
      </div>

      {/* Horizontal scrolling strip */}
      <div className="flex overflow-x-auto hide-scrollbar px-6 pb-8 gap-4 snap-x" data-id="element-210">
        {images.map((img, index) => <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} key={index} className="w-[280px] md:w-[320px] shrink-0 aspect-[4/3] bg-sand/30 rounded-[20px] overflow-hidden relative group cursor-pointer border border-sand flex items-center justify-center text-center hover:border-blue transition-colors snap-center shadow-sm hover:shadow-md" onClick={() => console.log('Track: gallery_open')} data-id="element-211">
            <img src={img.src} alt={img.alt} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-212" />
            <div className="absolute inset-0 bg-blue-deep/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-213"></div>
          </motion.div>)}
        {/* Spacer for right edge */}
        <div className="w-6 shrink-0" data-id="element-214"></div>
      </div>
    </section>;
}